import React, { useState, useEffect } from 'react';
import Label from '@/components/form/Label/Label';
import NewGeneralSearchForm from '@/components/general/Forms/NewGeneralSearchForm/NewGeneralSearchForm';
import HelmetComponent from '@/components/general/Helmet/HelmetComponent';
import ReactPixel from 'react-facebook-pixel';
import { useSelector } from 'react-redux';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import { cleanSrcForJPG } from '@/helpers/imagesHelpers';
import { GMapsMultipleMarkerComponent } from '@/components/reusable/GMapsComponent/GMapsMultipleMarkerComponent';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import AuthModal from '@/components/pages/WorkspaceMap/components/Modals/AuthModal';
import { setSelectedSpace } from '@/redux/actions/spaceActions';

const SearchView = props => {
  const {
    spacesDataFromBackend,
    lenguage,
    isSignInModalIsOpen,
    closeSignInModal,
    coordinatesForMapCenter,
    onClickMarkers,
    onGoogleLogin,
  } = props;

  console.log(isSignInModalIsOpen, 'props aqui');
  const loggedUser = useSelector(state => state.user);
  const lenguageData = lenguage;
  const [isVisibleNewForm, setIsVisibleNewForm] = useState(false);
  const [searchType, setSearchType] = useState('');
  const [mapKeyCounter, setMapKeyCounter] = useState(0);
  const [smallPins, setSmallPins] = useState(true);
  const languageData = useSelector(state => state.lenguage?.lang);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const hideNewForm = () => {
    window.scrollTo(0, 0);
    setIsVisibleNewForm(false);
    setSearchType('');
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const esDescription =
    'Somos un equipo de apasionados por la innovación y el buen vivir. Ofrecemos espacios de trabajo únicos con privacidad, buen diseño y sin ruido.';
  const enDescription =
    'We are a team of people passionate about innovation and good living. We offer unique work spaces with privacy, good design and no noise.';

  const texts = {
    ES: {
      perDay: 'por día',
      includesFees: 'incluye tarifas',
      unlockOffer: 'Desbloquea la oferta especial',
      back: 'Atrás',
      rating: '%',
      distance: 'km',
      minutesAway: 'minutos de distancia de',
    },
    EN: {
      perDay: 'per day',
      includesFees: 'includes fees',
      unlockOffer: 'Unlock the special offer',
      back: 'Back',
      rating: '%',
      distance: 'kms',
      minutesAway: 'minutes away from',
    },
  };

  const currentTexts = texts[lenguageData === 'ES' ? 'ES' : 'EN'];

  const goToSpaceDetails = spaceData => {
    ReactPixel.trackCustom('clickReservationButton', { clave: spaceData });
    dispatch(setSelectedSpace(spaceData));
    const customText = spaceData?.relationship_title
      ?.toLowerCase()
      ?.replace(/\s+/g, '-')
      ?.replace(/[^\w-]+/g, '');

    navigate(
      languageData === 'ES'
        ? '/detalle-espacio/' + customText + '/' + spaceData?.id_relationship
        : '/space-detail/' + customText + '/' + spaceData?.id_relationship,
      {
        state: { spaceData },
      },
    );
  };

  return (
    <div className="App">
      <HelmetComponent
        title={lenguageData === 'EN' ? 'Home - Popnest' : 'Inicio - Popnest'}
        description={lenguageData === 'EN' ? enDescription : esDescription}
        graphTitle={
          lenguageData === 'EN' ? 'Home - Popnest' : 'Inicio - Popnest'
        }
        graphDescription={lenguageData === 'EN' ? enDescription : esDescription}
      />
      <FlexContainer
        className={isVisibleNewForm ? 'bgWhite m-flex-column' : 'm-flex-column'}
      >
        {isVisibleNewForm && (
          <>
            <FlexContainer
              className={
                'flex-column margt100 m-margt120 format100 m-formatAuto padlr40 m-padlr0 d-hide'
              }
            >
              <button
                type="button"
                className={
                  'pointer bgWhite border-rad4px padlr20 marglr10 padtb6 borderGray050 fontGray500 text-16 m-margt40'
                }
                onClick={() => hideNewForm()}
              >
                <i className={'fa fa-arrow-left margr6'} aria-hidden="true" />
                {currentTexts.back}
              </button>
              <NewGeneralSearchForm searchType={searchType} />
            </FlexContainer>
            <FlexContainer className={'margt90 m-hide'}></FlexContainer>
          </>
        )}
      </FlexContainer>

      <FlexContainer
        className={
          'width100 padtb100 bgGradientSearchPurple flex-column  pos-rel'
        }
      >
        <FlexContainer
          className={'gap-10 padtb0 padlr120 '}
          style={{
            flexDirection: 'row',
            alignItems: 'flex-start',
            flexWrap: 'wrap',
          }}
        >
          <div style={{ flex: 1, minWidth: '300px' }}>
            <FlexContainer className={'gap-10 margb8 format95'}>
              {[1, 2, 3, 4].map(i => (
                <img
                  key={i}
                  src={`https://picsum.photos/seed/${i}/300/180`}
                  className={'format25 objectCover borderrad10'}
                />
              ))}
            </FlexContainer>

            <FlexContainer className={'flex-column gap-8'}>
              {spacesDataFromBackend.map(item => {
                const spaceInfo = item;
                const firstImage = (() => {
                  try {
                    const parsed =
                      spaceInfo?.url_img && spaceInfo?.url_img !== null
                        ? JSON.parse(spaceInfo?.url_img)
                        : JSON.parse(spaceInfo?.main_image);

                    const images =
                      Array.isArray(parsed) && parsed.length > 0
                        ? parsed
                        : [spaceInfo?.main_image].filter(Boolean);

                    return images[0] || null;
                  } catch {
                    return spaceInfo?.main_image || null;
                  }
                })();
                return (
                  <FlexContainer
                    key={item.id}
                    onClick={() => goToSpaceDetails(item)}
                    className={
                      'bgGradientSearchPurpleInput borderRad20 grayShadowBottom  fontWhite pointer align-items-center pos-rel overflow-hidden'
                    }
                    style={{
                      transition: 'all 0.3s ease',
                      minHeight: '120px',
                    }}
                    onMouseEnter={e => {
                      e.currentTarget.style.transform = 'translateY(-2px)';
                      e.currentTarget.style.boxShadow =
                        '0 8px 25px rgba(0,0,0,0.3)';
                    }}
                    onMouseLeave={e => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '';
                    }}
                  >
                    <img
                      src={cleanSrcForJPG(firstImage)}
                      className={
                        'width-200px height-130px objectCover borderrad14 noShrink'
                      }
                    />

                    <FlexContainer
                      className={
                        'justify-between gap-10 margtb0 marglr20 flex-1'
                      }
                      style={{
                        flexDirection: 'row',
                      }}
                    >
                      <FlexContainer className={'flex-column flex-1'}>
                        <Label className={'fontWhite text-22'}>
                          <strong>{item?.relationship_title}</strong>
                        </Label>

                        <Label
                          className={
                            'fontWhite opacity80 text-16 gap-6 flex-container align-items-center'
                          }
                        >
                          <i
                            className="fa-regular fa-star text-16"
                            style={{ opacity: 0.8 }}
                          />{' '}
                          {item.rating}
                          100%
                        </Label>
                        <Label
                          className={
                            'fontWhite opacity80 text-16  gap-6 flex-container align-items-center'
                          }
                        >
                          A 6.1km
                        </Label>
                        <Label
                          className={
                            'fontWhite opacity80 text-16 margb20 gap-6 flex-container align-items-center'
                          }
                        >
                          CDMX{' '}
                        </Label>

                        <Label
                          className={
                            'fontWhite opacity80 text-12 overflow-hidden'
                          }
                          style={{
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                          }}
                        >
                          {item.description}
                        </Label>
                      </FlexContainer>

                      <FlexContainer className={'flex-column items-align-end'}>
                        <Label className={'fontWhite text-22'}>
                          <strong>
                            {item?.currency + ' ' + item?.calculatedPrice}
                          </strong>
                        </Label>
                        <Label className={'fontWhite opacity80 text-14'}>
                          {currentTexts.perDay}
                        </Label>
                        <Label className={'fontWhite opacity80 text-14'}>
                          {currentTexts.includesFees}
                        </Label>
                      </FlexContainer>
                    </FlexContainer>

                    <FlexContainer
                      className={
                        'hover-overlay pos-abs top0 left0 right0 bottom0 borderrad20 align-items-center justify-center pointerEventsNone'
                      }
                      style={{
                        backgroundColor: 'rgba(85,109,170,0.9)',
                        opacity: 0,
                        transition: 'opacity 0.3s ease',
                      }}
                    >
                      <Label className={'fontWhite text-16'}>
                        {currentTexts.unlockOffer}
                      </Label>
                    </FlexContainer>
                  </FlexContainer>
                );
              })}
            </FlexContainer>
          </div>

          <FlexContainer
            className={
              'width-500px borderrad16 height100 overflow-hidden pos-sticky '
            }
            style={{
              boxShadow: '0 4px 20px rgba(0,0,0,0.25)',
              top: '100px',
              minWidth: '300px',
              flexGrow: 0,
            }}
          >
            <GMapsMultipleMarkerComponent
              smallPins={smallPins}
              setSmallPins={setSmallPins}
              mapKeyCounter={mapKeyCounter}
              setMapKeyCounter={setMapKeyCounter}
              center={{
                space_latitude: String(coordinatesForMapCenter?.lat),
                space_logitude: String(coordinatesForMapCenter?.lng),
              }}
              lenguage={languageData}
              markers={spacesDataFromBackend}
              onClickMarkers={onClickMarkers}
              customHeight={'920px'}
              isDesktop
            />
          </FlexContainer>
          {!loggedUser && (
            <AuthModal
              isOpen={isSignInModalIsOpen}
              onClose={closeSignInModal}
              languageData={languageData}
              onGoogleLogin={onGoogleLogin}
            />
          )}
        </FlexContainer>
      </FlexContainer>
    </div>
  );
};

export default SearchView;
